export default __webpack_public_path__ + "static/media/goal.b9078465.svg";